import { render, staticRenderFns } from "./SignUpViaEmailModal.vue?vue&type=template&id=52b0fe89&scoped=true"
import script from "./SignUpViaEmailModal.vue?vue&type=script&lang=js"
export * from "./SignUpViaEmailModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpViaEmailModal.vue?vue&type=style&index=0&id=52b0fe89&prod&lang=scss&scoped=true"
import style1 from "./SignUpViaEmailModal.vue?vue&type=style&index=1&id=52b0fe89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0fe89",
  null
  
)

export default component.exports